import axios from 'axios'

import { getBaseApiURL } from '@/utils/env'

export const privateClient = axios.create({
  baseURL: getBaseApiURL(),
  headers: {
    'Content-Type': 'application/json',
  },
})
